import { render, staticRenderFns } from "./ArrowOrder.vue?vue&type=template&id=6f77a06d&"
import script from "./ArrowOrder.vue?vue&type=script&lang=js&"
export * from "./ArrowOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports